import http from './axios';
// import {StringFormat} from '@/libs/util'

export interface DpFlowDto {
  id?: number;
  flowCategoryId?: number;
  flowCategoryName?: string;
  flowType?: number;
  flowCode?: string;
  flowName?: string;
  flowTag?: string;
  flowDesc?: string;
  flowConfig?: string;
  status?: number;
}

export interface DataprocessDto {
  id?: number;
  // 所属加工流程
  taskFlowId?: number;
  taskFlowName?: string;
  // 所属加工流程节点ID
  taskNodeId?: string;
  // 加工任务名称
  processJobName?: string;
  // 父加工任务
  parentJobCode?: string;
  // flinkx运行 job name
  jobFlinkName?: string;
  // 加工任务编码
  processJobCode?: string;
  // 加工任务类型 0-FlinkSQL 1-Python 2-Script 3-Doris
  processJobType?: number;
  // 加工任务标签
  processJobTag?: string;
  // 加工任务描述
  processJobDesc?: string;
  // 源表配置定义
  sourcesDsConfig?: Array<DpSourceInfo>;
  // 维度表配置定义
  lookupsDsConfig?: Array<DpLookupInfo>;
  // 目标表配置定义
  sinksDsConfig?: Array<DpSinkInfo>;
  // flink,python,script源代码 
  glueSource?: string; 
  // 参数配置
  paramsConfig?: Array<ParamItemDto>;
  // 作业运行配置
  jobConfig?: JobCronInfo;
  status?: number;
  // 是否是模板
  templateFlag?: number;
  // 审批状态
  //approveStatus?: number;
  //项目
  //projectId?: number;
}

export interface DpColumnCfg {
  id?: number;
  tableId?: number;
  pkFlag?: number;
  partitionFlag?: number;
  incrementFlag?: number;
  columnNameEn?: string;
  columnNameCn?: string;
  columnLogicName?: string;
  dataTypeEn?: string;
  dataTypeCn?: string;
  status?: number;
}

export interface DpSourceInfo {
  sourceDsId: number;
  sourceDsType: string;
  sourceDsName?: string;
  sourceDsTableId?: number;
  sourceDsTableName?: string;
  sourceDsTableLogicName?: string;
  sourceOtherColumns?: string;
  sourceDsColumns?: Array<DpColumnCfg>;
  // 偏移量类型:0-最新记录,1-最早记录,2-自定义参数
  startMode?: number;
  // 1-自增主键,2-时间,3-HIVE分区
  incrementType?: number;
  // 自定义偏移量
  startLocation?: string;
  incrementColumn?: string;
  incrementColumnType?: string;
  restoreColumn?: string;
  restoreColumnType?: string;
  // 间隔轮询时间。非必填(不填为离线任务)，无默认
  pollingInterval?: number;
  // 时间特征-处理时间 0-无，1-处理时间，2-事件时间
  timeFlag?: number;
  // 时间字段名称
  timeColumn1?: string;
  timeColumn2?: string;
  // Watermark值与Event Time值的偏移量，单位为秒
  timeOffset?: number;
  kafkaGroupId?: string;
  // kafka消费的启动模式，有效值为'earliest-offset'，'latest-offset'，'group-offsets'，'timestamp'和'specific-offsets'。
  startupMode?: string;
  // 从'timestamp'启动模式下使用的指定纪元时间戳（毫秒）开始
  startupTimestamp?: number;
  startupOffset?: string;
  parallelism?: number;

  dsList: any[];
  tableList: any[];
}

export interface DpSinkInfo {
  sinkDsId?: number;
  sinkDsType?: string;
  sinkDsName?: string;
  sinkDsTableId?: number;
  sinkDsTableName?: string;
  sinkDsTableLogicName?: string;
  sinkDsColumns?: Array<DpColumnCfg>;
  //分区字段与类型
  partitionColumn?: string;
  partitionColumnType?: string;
  parallelism?: number;

  dsList: any[];
  tableList: any[];
}

export interface DpLookupInfo {
  lookupDsId?: number;
  lookupDsType?: string;
  lookupDsName?: string;
  lookupDsTableId?: number;
  lookupDsTableName?: string;
  lookupDsTableLogicName?: string;
  lookupDsColumns?: Array<DpColumnCfg>;
  lookupOtherColumns?: string;
  // 主键
  lookupDsPkColumn?: string;
  // 维表缓存类型(NONE、LRU、ALL)，默认LRU
  cacheType?: string;
  cacheMaxRows?: number;
  cacheTtl?: number;
  parallelism?: number;

  dsList: any[];
  tableList: any[];
}

export interface ParamItemDto {
  // 参数编码
  fieldCode?: string;
  // 参数名称
  fieldName?: string;
  // 参数类型
  fieldType?: string;
  // 参数值
  fieldValue?: string;
}

export interface JobCronInfo {
  // 0-离线 1-实时
  jobType?: number;
  // 调度方式  0-手动,1-定时,2-周期
  triggerMode?: number;
  // 频率 0-秒；1-分；2-小时；3-日；4-月；5-年
  rate?: number;
  runDateStr?: string;
  runTimeStr?: string;
  day?: number;
  weekday?: string;
  season?: number;
  failRetryCount?: number;
  failTimeout?: number;
  // 数据时效 0->T,1->T-1,2->T-2
  dataDuration?: number;
  // cron表达式
  cronExpression?: string;
}


export default class DataprocessServices {
  private readonly flow_list_api = '/v1/data/taskflow/list';
  private readonly flow_info_api = '/v1/data/taskflow/info';
  private readonly flow_save_api = '/v1/data/taskflow/save';
  private readonly flow_update_api = '/v1/data/taskflow/update';
  private readonly flow_remove_api = '/v1/data/taskflow/delete';
  private readonly list_api = '/v1/data/processes/list';
  private readonly info_api = '/v1/data/processes/info';
  private readonly save_api = '/v1/data/processes/save';
  private readonly update_api = '/v1/data/processes/update';
  private readonly remove_api = '/v1/data/processes/delete';
  private readonly excuteSql_api = '/v1/data/processes/excuteSql';
  private readonly excuteLocal_api = '/v1/data/processes/excuteLocal';
  // private readonly parseFlinkSql_api = '/v1/data/processes/parseFlinkSql';

  constructor() {}

  /**  任务流程数据 */
  async getFlowList(params?: object): Promise<any> {
    let res: any = await http.get(this.flow_list_api, { params: params });
    return res.payload;
  }

  async getFlowInfo(id: string | number) {
    let res: any = await http.get(this.flow_info_api + '/' + id);
    return res.payload;
  }

  async addFlow(data: DpFlowDto) {
    let res: any = await http.post(this.flow_save_api, data);
    return res.header?.code == 200 ? res.payload : false;
  }

  async updateFlow(data: DpFlowDto): Promise<boolean> {
    let res: any = await http.post(this.flow_update_api, data);
    return res.header?.code == 200;
  }

  async removeFlow(id: string | number) {
    let res: any = await http.post(this.flow_remove_api, [id]);
    return res.header?.code == 200;
  }

  /**  主表单数据 */
  /** 目录 */
  // async getCategory(params?: object): Promise<any> {
  //   let res: any = await http.get(this.category_api, { params: params });
  //   return res.payload;
  // }
  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    let formData = this.transformData(res.payload);
    return formData;
  }

  async getInfoByNode(taskFlowId: string | number, taskNodeId: string) {
    let res: any = await http.get(this.info_api + '/' + taskFlowId + '/' + taskNodeId);
    return res.payload;
  }

  async add(data: DataprocessDto) {
    let submitData = this.formatFormData(data);
    const params = { ...submitData, processJobCode: 'DP_' + data.processJobCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: DataprocessDto): Promise<boolean> {
    let submitData = this.formatFormData(data);
    const params = { ...submitData, processJobCode: 'DP_' + data.processJobCode };
    let res: any = await http.post(this.update_api, params);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  async excuteSql(params: any) {
    let res: any = await http.post(this.excuteSql_api, params);
    return res.payload;
  }

  async excuteLocal(sqlStr: string) {
    let res: any = await http.post(this.excuteLocal_api, { sql: sqlStr });
    return res.payload;
  }

  // async parseFlinkSql(sql: string) {
  //   let res: any = await http.post(this.parseFlinkSql_api, sql);
  //   return res.payload;
  // }
  
  //提交数据格式化
  formatFormData(formData: DataprocessDto) {
    let submitData = { ...formData };
    // TODO
    return submitData;
  }
  //显示数据格式化
  transformData(formData: DataprocessDto) {
    let res = '';
    // TODO
    return formData;
  }
  
}
